<div class="d-flex align-items-center gap-3 mb-3">
  <h3 class="mb-0">Options</h3>
  @if (canWriteDeals() && !dealCancelled()) {
    <button
      [disabled]="isLocked()"
      class="btn btn-primary btn-h35 ms-auto"
      type="button"
      (click)="openAddOptionModal(); $event.stopPropagation()"
    >
      <i class="bi bi-plus fs-20"></i>
      Add Option
    </button>
  }
</div>

@if (products().length > 0) {
  <div class="pt-0">
    <div class="d-flex flex-column gap-3">
      @for (product of products(); track product.id; let i = $index) {
        <div
          class="bg-white border rounded-4 overflow-hidden p-3 cursor-pointer"
          [class.selected-addendum]="selectedProductId() === product.id"
          [class.addendum-expanded]="product.isExpanded"
          [class.pe-4]="product.isExpanded"
          (click)="$event.stopPropagation(); onProductSelect(product.id)"
        >
          <div class="position-relative pe-4">
            <!-- @if (product.linkedProducts && product.linkedProducts.length > 0) {
              <span
                class="align-items-center arrow-addendum-options bg-info-subtle d-flex end-0 justify-content-center ms-auto position-absolute px-1 py-1 rounded-2 text-nowrap"
                type="button"
                (click)="$event.stopPropagation(); product.isExpanded = !product.isExpanded"
              >
                @if (product.isExpanded) {
                  <i class="bi bi-chevron-down fs-18 lh-1"></i>
                } @else {
                  <i class="bi bi-chevron-right fs-18 lh-1"></i>
                }
              </span>
            } -->
            <deal-addendum-product-preview
              class="d-flex align-items-center w-100"
              [addendum]="dealAddendum()"
              [product]="product"
              (onChanges)="onChanges.emit()"
            ></deal-addendum-product-preview>
          </div>
          @if (product.linkedProducts && product.linkedProducts.length > 0 && product.isExpanded) {
            <div class="d-block p-3">
              <h3 class="mb-3 fw-semibold">Kit Options</h3>
              <div class="d-flex flex-column gap-3">
                @for (linkedProduct of product.linkedProducts; track linkedProduct.id) {
                  <div
                    class="border rounded-4 overflow-hidden p-3 cursor-pointer bg-light"
                    [class.selected-addendum]="selectedProductId() === linkedProduct.id"
                    (click)="$event.stopPropagation(); onKitProductSelect(linkedProduct.id)"
                  >
                    <div class="align-items-start align-items-xl1-center">
                      <deal-addendum-product-preview
                        class="d-flex align-items-center w-100"
                        [isKitLinkedProduct]="true"
                        [addendum]="dealAddendum()"
                        [product]="linkedProduct"
                        (onChanges)="onChanges.emit()"
                      ></deal-addendum-product-preview>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="d-flex align-items-center flex-wrap text-center bg-white rounded-4 p-3 gap-1 gap-lg-3 justify-content-center mt-2"
  >
    <p class="text-body-500 mb-0 text-surface-500">There are no options. start by adding options</p>
    <!-- <button
      class="btn btn-primary btn-h35"
      [disabled]="isLocked()"
      type="button"
      (click)="openAddOptionModal(); $event.stopPropagation()"
    >
      <i class="bi bi-plus fs-20"></i>
      Add Option
    </button> -->
  </div>
}

<ng-template #planChangeWarningModal>
  <div class="p-4 d-flex flex-column">
    <h5 class="fw-bold mb-3">Plan-changing option added</h5>
    <i class="bi bi-exclamation-triangle text-warning align-self-center" style="font-size: 2.5rem"></i>
    <p class="mt-3 mb-4">{{ planChangeWarningMessage() }}</p>
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-primary btn-h42" (click)="acknowledgePlanChangeWarning()">OK</button>
    </div>
  </div>
</ng-template>
